import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import { CbomProvider } from "./context/CbomContext";
import { SidebarProvider } from "./context/SidebarContext";
import { ProjectProvider } from "./context/ProjectContext";
import { CompanyProvider } from "./context/CompanyContext";
import { ModalProvider } from "./context/ModalContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ModalProvider>
      <SidebarProvider>
        <ProjectProvider>
          <CompanyProvider>
            <CbomProvider>
              <HashRouter>
                <App />
              </HashRouter>
            </CbomProvider>
          </CompanyProvider>
        </ProjectProvider>
      </SidebarProvider>
    </ModalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
